import React from "react";
import { Modal, Button, Typography } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import { useModalDismissal } from "components/shared-components/PreferenciasModais";

const { Title, Paragraph, Text } = Typography;

const NUMERO_NOVO_EXIBICAO = "(11) 95213-3660";
const WHATSAPP_LINK = "https://wa.me/5511952133660";

/**
 * Aviso automático de troca do número de WhatsApp do treino.io.
 * Aparece uma vez para todos os usuários do painel e não volta depois que é
 * fechado. Exibição, versão (a data antes na chave) e deadline (some a partir de
 * 05/08/2026) são server-driven — ver REGISTRO_MODAIS.novo_numero_whatsapp no back.
 */
const NovoNumeroWhatsAppModal = () => {
	const { deveExibir, dispensar } = useModalDismissal("novo_numero_whatsapp");

	const handleClose = () => dispensar("entendido");
	const handleSalvarNumero = () => dispensar("cta");

	return (
		<Modal
			open={deveExibir}
			onCancel={handleClose}
			footer={null}
			width={480}
			centered
			closable={false}
			bodyStyle={{ padding: 0, borderRadius: 12, overflow: "hidden" }}
			style={{ borderRadius: 12 }}
		>
			<div style={{ padding: "26px 24px 22px" }}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: 64,
						height: 64,
						margin: "0 auto 16px",
						borderRadius: "50%",
						background: "#e6fffb",
					}}
				>
					<WhatsAppOutlined style={{ fontSize: 34, color: "#25D366" }} />
				</div>

				<Title
					level={4}
					style={{
						textAlign: "center",
						margin: "0 0 18px",
						fontSize: 20,
						fontWeight: 700,
						lineHeight: 1.35,
					}}
				>
					Mudamos nosso número de WhatsApp
				</Title>

				<Paragraph style={{ fontSize: 14, marginBottom: 12 }}>
					Para falar com o suporte do treino.io, atualize o nosso contato! O
					número antigo será desativado e <strong>não receberá mais
					mensagens</strong>.
				</Paragraph>

				<div
					style={{
						textAlign: "center",
						background: "#f6ffed",
						border: "1px solid #b7eb8f",
						borderRadius: 8,
						padding: "14px 16px",
						marginBottom: 16,
					}}
				>
					<Text style={{ fontSize: 13, color: "#52c41a", display: "block" }}>
						Novo número
					</Text>
					<div
						style={{
							fontSize: 26,
							fontWeight: 800,
							lineHeight: 1.1,
							color: "#237804",
							margin: "2px 0 0",
						}}
					>
						{NUMERO_NOVO_EXIBICAO}
					</div>
				</div>

				<Paragraph style={{ fontSize: 14, marginBottom: 4 }}>
					Se você entrou em contato recentemente pelo outro número, por
					favor nos chame em nosso novo canal.
				</Paragraph>
				<Paragraph
					type="secondary"
					style={{ fontSize: 12, marginBottom: 16 }}
				>
					O Whatsapp bloqueou nosso número :(
				</Paragraph>

				<Button
					type="primary"
					size="large"
					block
					icon={<WhatsAppOutlined />}
					href={WHATSAPP_LINK}
					target="_blank"
					rel="noopener noreferrer"
					onClick={handleSalvarNumero}
					style={{
						height: 46,
						fontWeight: 600,
						background: "#25D366",
						borderColor: "#25D366",
						marginBottom: 10,
					}}
				>
					Salvar novo número
				</Button>
				<Button block type="text" onClick={handleClose} style={{ height: 40 }}>
					Entendi
				</Button>
			</div>
		</Modal>
	);
};

export default NovoNumeroWhatsAppModal;
